import * as actionTypes from 'src/old/actions';

const initialState = { bankEntities: [] };

const bankEntityReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BANK_ENTITIES: {
      return {
        ...state,
        bankEntities: action.response
      };
    }

    default: {
      return state;
    }
  }
};

export default bankEntityReducer;
